module.exports = __webpack_public_path__ + "static/media/21ECLAC9.eeb04a46.jpg";